import type { LensProposal } from '~/pages/LeLens/lensProposal';

import type { LeDataContentBlock } from '~/types/leData';

/** Only a server-backed candidate can name an edit target in an unbound conversation. */
export function candidateLensDraft(block: LeDataContentBlock): LensProposal | undefined {
  const proposal = block.payload;
  if (
    block.type !== 'lens_draft' ||
    typeof proposal.lensId !== 'string' ||
    !proposal.lensId ||
    typeof proposal.candidateId !== 'string' ||
    !proposal.candidateId ||
    typeof proposal.proposalId !== 'string' ||
    !proposal.proposalId ||
    typeof proposal.createdAt !== 'number' ||
    !Number.isFinite(proposal.createdAt) ||
    !Number.isInteger(proposal.baseVersion) ||
    Number(proposal.baseVersion) < 1 ||
    !Array.isArray(proposal.cards)
  ) {
    return undefined;
  }
  return proposal as unknown as LensProposal;
}

/** A Lens pane keeps its exact target match; a global thread accepts only checked candidates. */
export function shownLensDraftBlockId(
  blocks: ReadonlyArray<LeDataContentBlock>,
  lensId: string | undefined,
  allowGlobalLensDrafts: boolean,
): string | undefined {
  return [...blocks]
    .reverse()
    .find(
      (block) =>
        block.type === 'lens_draft' &&
        (lensId ? block.payload.lensId === lensId : allowGlobalLensDrafts && Boolean(candidateLensDraft(block))),
    )?.id;
}

/** Global answers can review independent targets; keep only the last draft per target. */
export function shownLensDraftBlockIds(
  blocks: ReadonlyArray<LeDataContentBlock>,
  lensId: string | undefined,
  allowGlobalLensDrafts: boolean,
): ReadonlySet<string> {
  if (lensId || !allowGlobalLensDrafts) {
    const id = shownLensDraftBlockId(blocks, lensId, allowGlobalLensDrafts);
    return new Set(id ? [id] : []);
  }
  const targets = new Set<string>();
  const shown = new Set<string>();
  for (const block of [...blocks].reverse()) {
    const proposal = candidateLensDraft(block);
    if (!proposal || targets.has(proposal.lensId)) continue;
    targets.add(proposal.lensId);
    shown.add(block.id);
  }
  return shown;
}
